<template>
  <div style="margin-bottom:56px;" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img :src="globalDicts.logo_color" alt="..." />
      </div>
      <div class="navbar_right">
        <div class="nav_tiyan" @click="goToPage">Contact Us</div>
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <Affix>
      <div class="nav_menu" ref="menu">
        <template v-for="(item, index) in menuList">
          <router-link v-if="!item.children || item.children.length === 0" class="menu_item" :to="item.routePath"
                       :key="item.id" :class="currentActive === index ? 'active' : ''" style="font-size: 15px">
            {{ item.menuName }}
          </router-link>
          <div v-else class="menu_item" @click="toggleSubmenu(item.id)"
               :class="currentActive === index ? 'active' : ''" style="font-size: 15px">
            {{ item.menuName }}
          </div>
          <div class="item_options_wrap" v-if="item.children && item.children.length > 0" :key="'sub-' + item.id">
            <transition name="submenu-slide">
              <div class="item_options" v-show="showSubmenu[item.id]" style="font-size: 15px">
                <a
                    v-for="(child, childIndex) in item.children"
                    :key="child.id"
                    @click="navigateTo(child.routePath)"
                    style="font-size: 15px"
                >
                  {{ child.menuName }}
                </a>
              </div>
            </transition>
          </div>
        </template>
      </div>
    </Affix>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      menuShow: false,
      showSubmenu: {}
    }
  },
  computed: {
    ...mapGetters(['getMenuList']),
    menuList() {
      return this.getMenuList
    },
    globalDicts() {
      return this.$store.getters.getDicts;
    },
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  mounted() {
    this.fetchMenuList().then(() => {
      for (let menu of this.menuList) {
        let ok = false
        if (menu.children) {
          for (let child of menu.children) {
            if (child.routePath === this.$route.path) {
              this.activeIndex = child.id + ''
              ok = true
              break
            }
          }
        }
        if (ok) {
          break
        }
      }
      // 初始化子菜单状态
      this.menuList.forEach(item => {
        this.$set(this.showSubmenu, item.id, false);
      });
    })
  },
  methods: {
    ...mapActions(['fetchMenuList']),
    moveMenu() {
      this.menuShow = !this.menuShow
      if (this.menuShow) {
        this.$refs.menu.style.top = '56PX'
      } else {
        this.$refs.menu.style.top = '-1000PX'
      }
    },
    toggleSubmenu(id) {
      this.showSubmenu[id] = !this.showSubmenu[id];
      // 关闭其他子菜单
      for (let key in this.showSubmenu) {
        if (key != id) {
          this.showSubmenu[key] = false;
        }
      }
    },
    gotoExperience() {
      // this.$router.push('/demo').catch((v) => { })
      this.closeMenu();
    },
    gobackHome() {
      this.$router.replace('/home').catch((v) => { })
    },
    navigateTo(routePath) {
      if (routePath) {
        this.$router.push(routePath).catch((v) => { })
      }
      // 点击后收起菜单
      this.closeMenu();
    },
    closeMenu() {
      this.menuShow = false;
      this.$refs.menu.style.top = '-1000PX';
    },
    goToPage() {
      this.$router.push('/fivenav/2')
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56PX;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15PX 0 15PX 15PX;
  align-items: center;
  position: fixed;
  top: 0;

  .navbar_left {
    flex: 1;
    background: #fff;

    img {
      width: 100%;
    }
  }

  .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    background: #fff;

    .nav_tiyan {
      width: 88PX;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
    }

    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 30PX;
      }
    }
  }
}

.active {
  color: #F39C00 !important;
  font-weight: bold;
}

/* 主菜单：高度自适应，去掉固定高度 */
.nav_menu {
  position: absolute;
  width: 100%;
  /* 去掉 height:450px */
  height: auto;
  max-height: calc(100vh - 56px); /* 最多撑满屏幕 */
  overflow-y: auto; /* 内容多了可以滚动 */
  list-style: none;
  left: 0;
  right: 0;
  top: -1000PX;
  box-sizing: border-box;
  background: #EFF0F1;
  box-shadow: 0 10PX 20PX rgba(0, 0, 0, .1);
  z-index: 10;
  transition: all 0.3s ease;
}

.menu_item {
  width: 100%;
  min-height: 40PX;
  font-size: 15px;
  background: #EFF0F1;
  color: #1c212d;
  padding: 20PX 30PX;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

/* 子菜单动画 */
.submenu-slide-enter-active,
.submenu-slide-leave-active {
  transition: all 0.3s ease;
}
.submenu-slide-enter-from {
  height: 0;
  opacity: 0;
}
.submenu-slide-leave-to {
  height: 0;
  opacity: 0;
}

.item_options_wrap {
  overflow: hidden;
}
.item_options {
  width: 100%;
  font-size: 15px;
  background: #fff;
  box-sizing: border-box;

  a {
    display: block;
    width: 100%;
    color: #666;
    padding: 15px 30PX;
    box-sizing: border-box;
  }
}
</style>